import React from 'react';
import { Box, Flex, Heading, Button, Text, useColorMode, HStack, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useWeb3 } from '../lib/Web3Provider';
import { formatAddress } from '../lib/utils';

const Header: React.FC = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { connected, address, connecting, connect, disconnect } = useWeb3();

  return (
    <Box as="header" bg={colorMode === 'dark' ? 'gray.800' : 'blue.600'} py={4} px={6} color="white">
      <Flex justify="space-between" align="center">
        <Flex align="center">
          <Heading as="h1" size="lg" fontWeight="bold" mr={8}>
            <Link as={RouterLink} to="/" _hover={{ textDecoration: 'none' }}>
              SmartLaw Token Manager
            </Link>
          </Heading>
          
          <HStack spacing={4} display={{ base: 'none', md: 'flex' }}>
            <Link as={RouterLink} to="/" fontWeight="medium" _hover={{ color: 'blue.100' }}>
              Home
            </Link>
            <Link as={RouterLink} to="/create" fontWeight="medium" _hover={{ color: 'blue.100' }}>
              Create Token
            </Link>
            <Link as={RouterLink} to="/mint" fontWeight="medium" _hover={{ color: 'blue.100' }}>
              Mint/Distribute
            </Link>
            <Link as={RouterLink} to="/configure" fontWeight="medium" _hover={{ color: 'blue.100' }}>
              Configure
            </Link>
            <Link as={RouterLink} to="/about" fontWeight="medium" _hover={{ color: 'blue.100' }}>
              About
            </Link>
          </HStack>
        </Flex>

        <Flex align="center">
          {connected ? (
            <Flex align="center">
              <Box 
                bg="green.500" 
                w={3} 
                h={3} 
                borderRadius="full" 
                mr={2} 
              />
              <Text mr={3}>
                {formatAddress(address)}
              </Text>
              <Button 
                colorScheme="whiteAlpha" 
                variant="outline" 
                size="sm"
                onClick={disconnect}
              >
                Disconnect
              </Button>
            </Flex>
          ) : (
            <Button 
              colorScheme="whiteAlpha" 
              size="sm"
              isLoading={connecting}
              onClick={connect}
            >
              Connect Wallet
            </Button>
          )}
          
          <Button 
            ml={4} 
            size="sm" 
            onClick={toggleColorMode} 
            variant="ghost"
          >
            {colorMode === 'dark' ? '🌞' : '🌙'}
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Header;